var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSintMaarten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4671.31 1166.285)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4671.31 -1254.561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.345,88.276h19.31a.358.358,0,0,1,.345.369v6.64H0v-6.64A.357.357,0,0,1,.345,88.276Z",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.655,263.009H.345A.357.357,0,0,1,0,262.64V256H20v6.64A.357.357,0,0,1,19.655,263.009Z",
    transform: "translate(0 -160.733)",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.136,104.232l10.21-6.681a.274.274,0,0,0,0-.459L.136,90.41A.362.362,0,0,0,0,90.689v13.263A.362.362,0,0,0,.136,104.232Z",
    transform: "translate(0 -2.045)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.158,
    cy: 1.158,
    r: 1.158,
    transform: "translate(2.623 92.696)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.737,218.671c0,.141.02.286.035.426.058.55.108,1.025-.42,1.209a2.671,2.671,0,0,1-.459.092,1.463,1.463,0,0,0-.571.15,1.464,1.464,0,0,0-.571-.15,2.676,2.676,0,0,1-.459-.092c-.528-.184-.478-.659-.42-1.209.015-.14.03-.285.035-.426a4.534,4.534,0,0,0-.162-1.262,1.262,1.262,0,0,0,.5.092,2.958,2.958,0,0,0,.3-.028,1.564,1.564,0,0,1,.742.021l.036.016.036-.016a1.564,1.564,0,0,1,.742-.021,2.958,2.958,0,0,0,.3.028,1.262,1.262,0,0,0,.5-.092A4.525,4.525,0,0,0,55.737,218.671Z",
    transform: "translate(-50.539 -123.746)",
    fill: "#8cd7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.181,212.418A4.572,4.572,0,0,1,50.4,211l-.152-.107a1,1,0,0,1-.6.172,2.782,2.782,0,0,1-.278-.027,1.789,1.789,0,0,0-.8.02,1.79,1.79,0,0,0-.8-.02c-.1.013-.2.025-.278.027a1,1,0,0,1-.6-.172l-.152.107a4.575,4.575,0,0,1,.22,1.421c0,.134-.019.275-.034.412-.058.552-.124,1.177.549,1.412a3.205,3.205,0,0,0,.5.1c.52.086.6.219.6.219s.078-.133.6-.219a3.205,3.205,0,0,0,.5-.1c.673-.235.607-.86.549-1.412C50.2,212.693,50.185,212.552,50.181,212.418Zm-.193.006c0,.141.02.285.035.426.058.55.108,1.025-.42,1.209a2.67,2.67,0,0,1-.459.092,1.464,1.464,0,0,0-.571.15,1.464,1.464,0,0,0-.571-.15,2.675,2.675,0,0,1-.459-.092c-.528-.184-.478-.659-.42-1.209.015-.14.03-.285.035-.426a4.534,4.534,0,0,0-.162-1.262,1.262,1.262,0,0,0,.5.092,2.963,2.963,0,0,0,.3-.028,1.563,1.563,0,0,1,.742.021l.036.016.036-.016a1.564,1.564,0,0,1,.742-.021,2.963,2.963,0,0,0,.3.028,1.263,1.263,0,0,0,.5-.092A4.525,4.525,0,0,0,49.988,212.424Z",
    transform: "translate(-44.79 -117.499)",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.234,229.168v-.425h.073v-.126h-.178v-.437h.178l-.816-.578v-.217h.113l-.366-.259-.366.259h.113v.217l-.816.578h.178v.437h-.178v.126h.073v.425h-.107v.184h2.2v-.184Z",
    transform: "translate(-61.457 -133.055)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.491 93.953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8,231.634a.1.1,0,1,0,.13-.118A.2.2,0,0,0,64.8,231.634Z",
    transform: "translate(-64.564 -231.215)",
    fill: "#41aa5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.048,230.844a.1.1,0,1,0,.031-.172A.2.2,0,0,0,68.048,230.844Z",
    transform: "translate(-67.689 -230.406)",
    fill: "#41aa5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.09,228.741a.1.1,0,1,0-.123-.124A.2.2,0,0,0,70.09,228.741Z",
    transform: "translate(-69.534 -228.41)",
    fill: "#41aa5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.31,226.067a.1.1,0,1,0-.175,0A.2.2,0,0,0,70.31,226.067Z",
    transform: "translate(-69.695 -225.847)",
    fill: "#41aa5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.533,227.254a.1.1,0,1,0-.172.032A.2.2,0,0,0,60.533,227.254Z",
    transform: "translate(-60.33 -226.979)",
    fill: "#41aa5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.77,224.512a.13.13,0,1,0-.158-.186A.323.323,0,0,0,59.77,224.512Z",
    transform: "translate(-59.612 -224.317)",
    fill: "#41aa5a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.433,228.627a2.853,2.853,0,1,0-.058.06A.06.06,0,0,0,66.433,228.627Z",
    transform: "translate(-63.43 -134.38)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.036,
    cy: 0.036,
    r: 0.036,
    transform: "translate(2.849 94.211)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.88,227.679a2.283,2.283,0,1,0-.048.049A.049.049,0,0,0,62.88,227.679Z",
    transform: "translate(-60.067 -133.492)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.029,
    cy: 0.029,
    r: 0.029,
    transform: "translate(2.687 94.158)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.462,226.3a1.655,1.655,0,1,0-.035.036A.036.036,0,0,0,68.462,226.3Z",
    transform: "translate(-65.467 -132.196)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.021,
    cy: 0.021,
    r: 0.021,
    transform: "translate(2.904 94.083)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.28,224.853a1.662,1.662,0,1,0-.035.036A.036.036,0,0,0,65.28,224.853Z",
    transform: "translate(-62.418 -130.81)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.771 93.842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.021,
    cy: 0.021,
    r: 0.021,
    transform: "translate(0 0.18)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.406,222.37h.669a.367.367,0,0,0-.231-.205,1.046,1.046,0,0,0,.012-.161c0-.2-.052-.366-.116-.366s-.116.164-.116.366a1.042,1.042,0,0,0,.012.161A.367.367,0,0,0,105.406,222.37Z",
    transform: "translate(-103.772 -221.638)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.85,259.135a2.561,2.561,0,0,1-2.558-2.558h.483a2.075,2.075,0,1,0,4.151,0h.483A2.561,2.561,0,0,1,31.85,259.135Z",
    transform: "translate(-28.068 -161.279)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.109,198.4h-.417a.076.076,0,1,0,0-.152h-.531a.076.076,0,0,0,0,.152h-.948a.114.114,0,1,0,0,.227h.341a.076.076,0,0,0,0,.152h.683a.076.076,0,0,0,0-.152h.872a.114.114,0,1,0,0-.227Z",
    transform: "translate(-62.379 -105.383)",
    fill: "#c87878"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSintMaarten);
export default __webpack_public_path__ + "static/media/sint-maarten.e07fdf4106561164cde98c8255978775.svg";
export { ForwardRef as ReactComponent };